(() => {
  const currency = window.Shopify?.currency?.active || window.LUMY_CURRENCY || 'USD';
  const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency});
  const decimals = formatter.resolvedOptions().maximumFractionDigits;
  window.LUMY_MONEY = {
    currency,
    format(cents) { return formatter.format(Number(cents) / 100); },
    fromUSD(cents) { return Number(cents) * (Number(window.Shopify?.currency?.rate) || 1); },
    precision(cents) {
      const step = 100 / 10 ** decimals;
      return Math.round(Number(cents) / step) * step;
    },
    round(cents) {
      if (currency === 'USD') return Math.floor(Number(cents) / 100) * 100 + 99;
      return this.precision(cents);
    }
  };
  document.querySelectorAll('[data-base-saving]').forEach(el => {el.textContent = window.LUMY_MONEY.format(window.LUMY_MONEY.fromUSD(3000));});
  document.addEventListener('change', event => {
    if (event.target.matches('[data-country-selector]')) event.target.form.requestSubmit();
  });
})();
